import React, { useEffect, useState } from 'react'
import { getGallaryData } from '../../../Services/AdminServices';
import { Box, Card, Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import Loader from '../../../Components/Loader/Loader';

const Item = styled(Card)(({ theme }) => ({
    backgroundColor: "#fff",
    boxShadow: 'none',
    borderRadius: '10px',
    padding: '10px',
}));

function Gallary() {

    const [gallary, setGallary] = useState([]);
    const [loading, setLoading] = useState(false);

    const getList = async () => {
        setLoading(true);
        try {
            await getGallaryData().then((res) => {
                setGallary(res?.data?.resources);
            })
        } catch (error) {
            setLoading(false);
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getList();
    }, []);

    if (loading) {
        return <Loader />;
    }

    return (
        <div>
            <Box>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                    Gallary
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Item>
                            <Box className="section-category-header-flex">
                                <div className='category-header-icon'></div>
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    Gallary List
                                </Typography>
                            </Box>
                        </Item>
                    </Grid>
                    {gallary && gallary.length === 0 ? (
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Item>
                                <Typography textAlign="center" sx={{ fontWeight: 'bold', fontSize: 20 }}>No Records Found...</Typography>
                            </Item>
                        </Grid>
                    ) : (gallary && gallary.map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                            <Item>
                                {/* <PhotoProvider>
                                    <PhotoView src={item?.url}> */}
                                <div className="container">
                                    <img src={item?.url} alt="Avatar" className="image" />
                                </div>
                                {/* </PhotoView>
                                </PhotoProvider> */}
                            </Item>
                        </Grid>
                    )))}
                </Grid>
            </Box>
        </div>
    )
}

export default Gallary;